<template lang="pug">
  div(:class="offset")
    .sidebar-layout__toolbar(
      v-if="!isMobile && !isConsultant")
      v-btn(
        v-if="!isConsultant && userType !== 'employee'"
        medium
        :disabled="!allowAddAnimalType"
        @click="modal.showCreateType = true")
        v-icon(
          position-left
          font-size="1"
          icon="plus")
        span {{ 'base.add_type' | translate }}
    template(
      v-else)
      v-btn(
        v-if="!isConsultant && userType !== 'employee'"
        fab
        :disabled="!allowAddAnimalType"
        @click="modal.showCreateType = true")
        v-icon(
          font-size="1.2"
          icon="plus")

    v-dialog(
      max-width="400"
      v-model="modal.showCreateType")
      create-type-modal(
        @close="closeCreateModal"
        @update="onUpdate")

    v-dialog(
      max-width="400"
      v-model="modal.showSettingsType")
      settings-type-modal(
        v-if="modal.showSettingsType"
        @close="closeSettingsModal"
        @update="onUpdateAndClose"
        @remove="onUpdateAndClose")

    template(v-if="!isMobile")
     types-table(
       ref="childComponentRef")

    template(v-if="isMobile")
      types-table-mobile(
        ref="childComponentMobileRef")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import api from '@/api'
import adaptationMixin from '@/mixins/adaptation.mixin.js'

import CreateTypeModal from './modals/CreateTypeModal'
import SettingsTypeModal from './modals/SettingsTypeModal'

const TypesTable = () => import('./TypesTable')
const TypesTableMobile = () => import('./TypesTableMobile')

export default {
  name: 'AnimalsTypes',

  mixins: [adaptationMixin],

  components: {
    TypesTable,
    TypesTableMobile,
    CreateTypeModal,
    SettingsTypeModal
  },

  async created () {
    try {
      const { data } = await api.account.get()
      this.userType = data.user_type
    } catch (error) {
      console.error('Failed to fetch user type:', error)
      this.userType = null
    }
  },

  data: () => ({
    userType: null,
    modal: {
      showCreateType: false,
      showSettingsType: false
    }
  }),

  computed: {
    ...mapGetters('animaltypes', [
      'currentAnimalType'
    ]),

    offset () {
      return (this.isConsultant && this.isDesktop)
        ? 'offset-top'
        : null
    },

    allowAddAnimalType () {
      return this.hasPermission('animaltype', 'add')
    }
  },

  watch: {
    currentAnimalType (newVal) {
      if (newVal !== null && !this.modal.showSettingsType) {
        this.modal.showSettingsType = true
      }
    }
  },

  methods: {
    ...mapActions('animaltypes', [
      'closeAnimalType'
    ]),

    closeCreateModal () {
      this.modal.showCreateType = false
    },

    closeSettingsModal () {
      this.modal.showSettingsType = false
      this.closeAnimalType()
    },

    onUpdate () {
      if (this.$refs.childComponentRef) {
        this.$refs.childComponentRef.updateData()
      }
      if (this.$refs.childComponentMobileRef) {
        this.$refs.childComponentMobileRef.updateData()
      }
    },

    async onUpdateAndClose () {
      await this.onUpdate()
      await this.$nextTick()
      this.closeSettingsModal()
    }
  }
}
</script>